import { format } from "date-fns";

const DATE_TIME_FORMAT = `dd.MM HH:mm`;

const formatDateTime = value => (
  format(value, DATE_TIME_FORMAT)
);

export default formatDateTime;
